import { render, staticRenderFns } from "./Especie.vue?vue&type=template&id=a06afcae&scoped=true"
import script from "./Especie.vue?vue&type=script&lang=js"
export * from "./Especie.vue?vue&type=script&lang=js"
import style0 from "../../../../css/crud.css?vue&type=style&index=0&id=a06afcae&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06afcae",
  null
  
)

export default component.exports